import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * アイコン掲載順一覧取得取得
 *
 * @export
 * @class GetMarkPublishOrderList
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMarkPublishOrderList extends PlessJsonResponderSub<any> {
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkPublishOrderList
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMarkPublishOrderList
   */
  execute(successFunc: Function = null): void {
    this.successFunc = successFunc;
    this.send('getMarkPublishOrderList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkPublishOrderList
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
